import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../../form_helpers';
import { forgottenPassword, resetForgottenPassword } from '../../../actions';
import { connect } from 'react-redux';
import MyS4CAPIErrorAlert from '../alerts/MyS4CAPIErrorAlert';
import { FORGOT_PWORD_ERROR } from '../../../actions/types';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

const submit = (values, dispatch, props) => {
  if (values.email) {
    props.forgottenPassword(values.email);
  }
};

const validate = (values, props) => {
  const errors = {};
  if (!values.email) {
    errors.email = props.strings.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = props.strings.invalidEmail;
  }
  return errors;
};

class ForgotPasswordForm extends Component {
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      this.props.reset();
    }
    if (nextProps.success === true) {
      this.props.resetForgottenPassword();
      this.props.handleOpenModal(this.props.strings.emailResetPassword);
    }
  };

  render() {
    const { handleSubmit, submitting, pristine, strings, errorMsg } =
      this.props;
    const trans = strings;

    return (
      <div className="form form--no-btm-pad">
        <header className="form__header">
          <div className="form__instruct">
            <H3>{trans.changePassword}</H3>
            <P>{trans.forgotPasswordIntstruct}</P>
          </div>
        </header>
        {/* TODO: add loading button */}
        <form className="form__form" onSubmit={handleSubmit(submit)}>
          <Field
            name="email"
            type="email"
            component={renderField}
            label={trans.email}
            autoFocus={true}
          />

          <MyS4CAPIErrorAlert
            errorMessage={errorMsg}
            errorType={FORGOT_PWORD_ERROR}
          />
          <FormActions>
            <ButtonV2
              onClick={handleSubmit(submit)}
              label={trans.resetMyPassword}
              size="large"
              disabled={pristine || submitting}
            />
            <ButtonSubmit aria-hidden="true" />
          </FormActions>
        </form>
      </div>
    );
  }
}

const H3 = styled.h3`
  margin-top: 0;
  margin-bottom: 23px;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
`;

const P = styled.p`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull} !important;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
`;

const FormActions = styled.div`
  display: flex;
  justify-content: center;
  margin: 34px 0 29px;
`;

const ButtonSubmit = styled.button`
  position: absolute;
  left: -9999px;
`;

ForgotPasswordForm = reduxForm({
  form: 'forgotPassword',
  validate,
})(ForgotPasswordForm);

ForgotPasswordForm = connect(
  (state) => ({
    curLang: state.curLang,
    success: state.forgottenPassword.success,
    errorMsg: state.forgottenPassword.error,
  }),
  { forgottenPassword, resetForgottenPassword } // bind account loading action creator
)(ForgotPasswordForm);

export default ForgotPasswordForm;
